import { Injectable } from '@angular/core';
import { IDatiqLogService } from '../models';
import { DatiqLogStateService } from './datiq-log-state.service';

@Injectable({
    providedIn: 'root',
})
export class DatiqLogService implements IDatiqLogService {
    constructor(private _state: DatiqLogStateService) {}

    log(message: string, info?: unknown): void {
        this._state.log(message, info);
    }
    error(message: string, info?: unknown): void {
        this._state.error(message, info);
    }
    warn(message: string, info?: unknown): void {
        this._state.warn(message, info);
    }
    debug(message: string, info?: unknown): void {
        this._state.debug(message, info);
    }
    jsError(message: string, error: Error, info?: unknown): void {
        this._state.jsError(message, error, info);
    }
}
